module.exports = __webpack_public_path__ + "img/lg3.bd5e2c35.jpg";